import { countCompleteSelfFundingAccounts } from '@/features/funding-sources';
import { consumerStepPath } from '../lib/paths';
import { useConsumerClient } from './use-consumer-client';

/**
 * Where "I want to self-fund the entire event" from the options leads once the self-funding steps are
 * open: the projection made for that choice (see `useProjectionChoices`), through the account steps
 * first when no account is complete yet. Going straight there, the return point is the paywall.
 */
export function useSelfFundChoicePath(clientId: string): string {
  const { client } = useConsumerClient(clientId);
  const hasAccounts = countCompleteSelfFundingAccounts(client?.multipleFundingSources?.selfFunding) > 0;
  return hasAccounts
    ? consumerStepPath(clientId, 'assessment-projection', 'self-fund')
    : consumerStepPath(clientId, 'assets', 'options');
}
